var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5667 1.80803C7.81078 2.05211 7.81078 2.44783 7.5667 2.69191L4.25864 5.99997L7.5667 9.30803C7.81077 9.55211 7.81077 9.94783 7.5667 10.1919C7.32262 10.436 6.92689 10.436 6.68281 10.1919L2.93281 6.44191C2.68874 6.19783 2.68874 5.80211 2.93281 5.55803L6.68281 1.80803C6.92689 1.56395 7.32262 1.56395 7.5667 1.80803Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back-icon.2018cabc.svg";
export { ForwardRef as ReactComponent };